<div class="container-fluid vh-100 py-5">
    <div class="row d-flex justify-content-center align-items-center h-100">
        <div class="col-12 col-md-8 col-lg-6 col-xl-5 ">

            <div class="card shadow-sm my-auto" style="border-radius: 1rem;">
                <div class="card-body p-5 ">
                    <div class="row mb-3">
                        <div class="col-lg-8 col-sm-6">
                            <a href="/" class="logo" >
                                <img src="../../../../assets/img/afg-comply365.svg" class="w-50"/>
                            </a>
                        </div>
                        <div class="col-lg-4 col-sm-6 text-lg-end text-md-end text-sm-left">
                            <h4 class="text-uppercase text-weight-bold m-0 pt-3"><i class="fa fa-user mr-xs"></i> You are now logged out.</h4>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">

                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12 text-center text-muted mt-md mb-md">
                    <small>&copy; Copyright {{year}}. All Rights Reserved.</small>
                </div>
            </div>
            <pre style="display:none">2023-09-22</pre>
        </div>
    </div>

</div>
